class SearchPeople {
    constructor() {
        this.input = document.querySelector('.search-people__input');
        this.list = document.querySelector('.search-people__list');

        if (!this.input || !this.list) return; // Exit if essential elements are missing

        this.hideList();
        this.events();
    }

    events() {
        this.input.addEventListener('keyup', () => {
            this.search();
        });

        this.input.addEventListener('focus', () => {
            this.showList();
        });

        this.input.addEventListener('blur', () => {
            setTimeout(() => {
                if (!this.list.contains(document.activeElement)) {
                    this.list.classList.add('hide');
                }
            }, 100);
        });
    }

    // Methods
    search() {
        const search = this.input.value.toLowerCase();

        this.list.querySelectorAll('li').forEach(li => {
            const value = li.dataset.value.toLowerCase();
            if (value.includes(search)) {
                li.classList.remove('hide');
            } else {
                li.classList.add('hide');
            }
        });
    }

    showList() {
        this.list.classList.remove('hide');
        this.list.click();
    }

    hideList() {
        this.list.classList.add('hide');
    }
}

export default SearchPeople;